import { createFileRoute } from '@tanstack/react-router';
import { CampaignsOverviewForward } from '@/pages/workspaces/automations/[campaignId]/overview/routing';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/campaigns/$campaignId/overview/')({
  component: CampaignsOverviewForward,
});
